// extracted by mini-css-extract-plugin
export default {"InlineBadge":"📚19-10-2_NZvf","BeforeBadge":"📚19-10-2amHCe","AfterBadge":"📚19-10-2bk89x","size_medium":"📚19-10-2lARHy","size_small":"📚19-10-2bWHX7","NotificationDot":"📚19-10-2lUQtB"};